import { useCallback, useMemo, useState } from "react";
import { CreateDaysSupply, InputType } from "src/api/types";

type FormValues = Pick<CreateDaysSupply, "days_supply">;

export const useInputs = () => {
  const [values, setValues] = useState<FormValues>({
    days_supply: 0,
  });

  const setFields = useCallback(
    <K extends keyof FormValues>(key: K, value: FormValues[K]) => {
      setValues((prev) => ({ ...prev, [key]: value }));
    },
    [],
  );

  const inputs: InputType<CreateDaysSupply>[] = useMemo(
    () => [
      {
        type: "number",
        name: "days_supply",
        label: "Days Supply",
        required: true,
        value: values.days_supply,
        parse: (raw) => (raw.trim() === "" ? null : Number(raw)),
        onChange: (v) => setFields("days_supply", v ?? 0),
      },
    ],
    [setFields, values.days_supply],
  );

  return { values, inputs, setValues };
};
